import React, { useEffect, useState } from "react";
import "./Multimedia_Services_Benefits.css";
import Multimedia_Services_Benefits_card from "../../../Common_Component/Multimedia_Services_Benefits_card/Multimedia_Services_Benefits_card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useParams } from "react-router-dom";

function Multimedia_Services_Benefits() {
  const [howItWorksData, setHowItWorksData] = useState([]);
  const { id } = useParams();

  console.log("Multimedia_Services_Benefits", Multimedia_Services_Benefits);

  const data = [
    {
      id: 1,

      innerData: [
        {
          id: 1,
          title: "Attention-Grabbing",
          descn:
            "Bright, vivid displays ensure your ad gets noticed.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Digital/img1.png",
        },
        {
          id: 1,
          title: "Durability",
          descn:
            "Designed to withstand outdoor conditions while maintaining high performance.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Digital/img2.png",
        },
        {
          id: 1,
          title: "Versatility",
          descn:
            "Bright, vivid displays ensure your ad gets noticed.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Digital/img3.png",
        },
        {
          id: 1,
          title: "Cost-Effective",
          descn:
            "Reusable screens minimize ongoing costs compared to traditional billboards.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Digital/img4.png",
        },
        {
          id: 1,
          title: "Flexible Scheduling",
          descn:
            "Update ads based on time of day, audience demographics, or events.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Digital/img5.png",
        },
      ],
    },


    {
      id: 2,

      innerData: [
        {
          id: 1,
          title: "Wide Reach",
          descn:
            "Radio reaches urban, rural, and regional audiences effectively.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Redio/img1.png",
        },
        {
          id: 1,
          title: "Local Targeting",
          descn:
            "Tailor your ads for specific languages, regions, or communities.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Redio/img2.png",
        },
        {
          id: 1,
          title: "High Frequency",
          descn:
            "Repeated airing builds brand recall.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Redio/img3.png",
        },
        {
          id: 1,
          title: "Cost-Effective",
          descn:
            "Affordable campaigns that deliver results.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Redio/img4.png",
        },
        {
          id: 1,
          title: "Emotional Connection",
          descn:
            "Audio messaging creates a personal, relatable impact.",
          image:
          "/Assets/Images/Service/Services/multimediaAdvertisement/Redio/img5.png",
        },
      ],
    },


    {
      id: "3",

      innerData: [
        {
          id: 1,
          title: "Massive Reach",
          descn:
            "Connect with millions of viewers nationwide.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/TVS/img1.png",
        },
        {
          id: 1,
          title: "Creative Freedom",
          descn:
            "Use storytelling, visuals, and sound for compelling communication.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/TVS/img2.png",
        },
        {
          id: 1,
          title: "Demographic Targeting ",
          descn:
            "Choose specific channels or shows to reach your ideal audience.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/TVS/img3.png",
        },
        {
          id: 1,
          title: "Builds Trust",
          descn:
            "TV advertising enhances brand credibility and recall.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/TVS/img4.png",
        },
        {
          id: 1,
          title: "Analytics-Driven",
          descn:
            "Get measurable data on viewership and performance.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/TVS/img5.png",
        },
      ],
    },

    {
      id: "4",

      innerData: [
        {
          id: 1,
          title: "Captive Audience",
          descn:
            "Viewers are focused and attentive during movie screenings.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Theator/img1.png",
        },
        {
          id: 1,
          title: "Premium Branding",
          descn:
            "Association with cinemas elevates your brand perception.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Theator/img2.png",
        },
        {
          id: 1,
          title: "Targeted Reach ",
          descn:
            "Advertise at specific theatres or blockbuster releases.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Theator/img2.png",
        },
        {
          id: 1,
          title: "Multi-Format Options",
          descn:
            "Use video ads, slides, or physical lobby branding.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Theator/img4.png",
        },
        {
          id: 1,
          title: "High Recall",
          descn:
            "Big-screen visuals make your ad memorable.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Theator/img5.png",
        },
      ],
    },


    {
      id: "5",

      innerData: [
        {
          id: 1,
          title: "Premium Audience",
          descn:
            "Connect with millions of viewers nationwide.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Airport/img1.png",
        },
        {
          id: 1,
          title: "Extended Exposure",
          descn:
            "Longer dwell times ensure your ad is noticed and remembered.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Airport/img2.png",
        },
        {
          id: 1,
          title: "Brand Association ",
          descn:
            "Gain credibility by associating your brand with an upscale environment.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Airport/img3.png",
        },
        {
          id: 1,
          title: "High Customization",
          descn:
            "Target by time slots, traveller profiles, or specific terminal areas..",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Airport/img4.png",
        },
        {
          id: 1,
          title: "Wide Reach",
          descn:
            "Airports serve as hubs for domestic & international travellers, ensuring expansive brand visibility.",
          image:
            "/Assets/Images/Service/Services/multimediaAdvertisement/Airport/img5.png",
        },
      ],
    },
  ];

  useEffect(() => {
    const filteredArray = data?.filter((item) => item?.id == id);

    console.log("filteredArray", filteredArray);

    setHowItWorksData(filteredArray);
  }, [id]);

  return (
    <section className="Multimedia_Services_Benefits">
      <div className="container">
        <div className="Multimedia_Services_Benefits_content">
          <div className="heading_holder">
            <h1>Benefits</h1>
          </div>

          <Swiper
            className="mySwiper Multimedia_Services_Benefits_swiper"
            slidesPerView={5}
            spaceBetween={20}
            breakpoints={{
              // When the viewport width is >= 320px
              320: {
                slidesPerView: 1,
              },

              // When the viewport width is >= 320px
              375: {
                slidesPerView: 1.2,
              },
              // When the viewport width is >= 480px
              425: {
                slidesPerView: 1.5,
              },
              // When the viewport width is >= 640px
              575: {
                slidesPerView: 3,
              },
              // When the viewport width is >= 768px
              768: {
                slidesPerView: 3.5,
              },
              // When the viewport width is >= 1024px
              1200: {
                slidesPerView: 5,
              },
            }}
          >
            {howItWorksData?.[0]?.innerData?.length > 0 &&
              howItWorksData?.[0]?.innerData?.map((item) => {
                return (
                  <SwiperSlide>
                    <Multimedia_Services_Benefits_card
                      headingText={item?.title}
                      text={item?.descn}
                      image={item?.image}
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Multimedia_Services_Benefits;
